export const isLoggedIn = (idfarmer) => {
  return fetch("/api/auth/islogged").then((res) => res.json());
};

export const getFarmerId = (idfarmer) => {
  return fetch("/api/farmer/" + idfarmer).then((res) => res.json());
};

export const getCrops = () => {
  return fetch("/api/crops/getcrops").then((res) => res.json());
};

export const getMap = (idcrop) => {
  return fetch("/api/crops/getmap/" + idcrop ).then((res) => res.json());
};

export const getDates = (idcrop) => {
  return fetch("/api/crops/getdates/"+idcrop).then((res) => res.json());
};

export const getVisuals = (idcrop) => {
  return fetch("/api/crops/createvisuals/"+idcrop).then((res) => res.json());
};

export const getTimeseries = (idcrop) => {
  return fetch("/api/crops/gettimeseries/"+idcrop).then((res) => res.json());
};

export const getProduction = (idcrop) => {
  return fetch("/api/crops/getproduction/"+idcrop).then((res) => res.json());
};

export const getProductionAvailables=(idcrop, date)=>{
  return fetch("/api/crops/getproductionAvailables/"+idcrop+"/"+date).then((res) => res.json());
}

/////////////////////////////////////////////////////////////////////////

export const checkAuthentication = (setUser, setIsAuthenticated) => {
  const userFromState = getUserFromState();
  return userFromState && userFromState.isAuthenticated;
};  

export const getUserFromState = () => {
  const userString = localStorage.getItem('userData');
  if (userString) {
    return JSON.parse(userString);
  } else {
    return null;
  }
};

export const setUserToState = (userData) => {
  localStorage.setItem('userData', JSON.stringify(userData));
};

export const removeUserFromState = () => {
  localStorage.removeItem('userData');
};